export default class SaidaAdicionarProduto {
  constructor(id = 0, idRomaneio = "", produtos = []) {
    this.id = id
    this.IdRomaneio = idRomaneio
    this.Produtos = produtos
  }
}
